// ============================================================
// THE COMPANY — Custom React Flow Edge for Dependencies
// ============================================================

import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from "@xyflow/react";
import { useCompanyStore } from "../../store/useCompanyStore";

export default function DependencyEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  style = {},
}: EdgeProps) {
  const deleteDependency = useCompanyStore((s) => s.deleteDependency);

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  // Extract the real dependency ID from edge id format "dep-{uuid}"
  const depId = id.startsWith("dep-") ? id.slice(4) : id;

  return (
    <>
      <BaseEdge
        path={edgePath}
        style={{
          stroke: "#6366f1",
          strokeWidth: 1.5,
          strokeDasharray: "6 3",
          ...style,
        }}
      />
      <EdgeLabelRenderer>
        <div
          className="nodrag nopan pointer-events-auto absolute flex items-center gap-1.5"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          {/* Label text */}
          {label && (
            <span
              className="text-[10px] font-medium rounded px-1.5 py-0.5"
              style={{
                backgroundColor: "#1a1a24",
                color: "#9090a0",
                border: "1px solid #2a2a3a",
              }}
            >
              {label}
            </span>
          )}

          {/* Delete button */}
          <button
            type="button"
            className="flex items-center justify-center rounded-full transition-colors cursor-pointer"
            style={{
              width: 16,
              height: 16,
              backgroundColor: "#1a1a24",
              color: "#9090a0",
              border: "1px solid #2a2a3a",
              fontSize: 10,
              lineHeight: 1,
            }}
            title="Remove dependency"
            onClick={(e) => {
              e.stopPropagation();
              deleteDependency(depId);
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor =
                "#ef4444";
              (e.currentTarget as HTMLButtonElement).style.color = "#fff";
              (e.currentTarget as HTMLButtonElement).style.borderColor =
                "#ef4444";
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.backgroundColor =
                "#1a1a24";
              (e.currentTarget as HTMLButtonElement).style.color = "#9090a0";
              (e.currentTarget as HTMLButtonElement).style.borderColor =
                "#2a2a3a";
            }}
          >
            &times;
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
